"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var PointConverter_1 = require("./PointConverter");

var PointsVectorConverter =
/** @class */
function () {
  function PointsVectorConverter() {}

  PointsVectorConverter.prototype.fromMessage = function (message) {
    return {
      points: message.points.map(function (x) {
        return PointConverter_1.pointConverter.fromMessage(x);
      })
    };
  };

  PointsVectorConverter.prototype.toMessage = function (object) {
    return {
      points: object.points.map(function (x) {
        return PointConverter_1.pointConverter.toMessage(x);
      })
    };
  };

  return PointsVectorConverter;
}();

exports.PointsVectorConverter = PointsVectorConverter;
exports.pointsVectorConverter = new PointsVectorConverter();